import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions, // ✅ add this
  TextField,
  Button,
  Typography,
} from "@mui/material";
import { useAppContext } from "../../../context/appContext";
import userService from "../../../service/user.service";

export default function ResetPasswordDialog({ open, onClose }) {
  const { isMobile } = useAppContext();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const handleSubmit = async () => {
    await userService.requestPasswordReset(email);
    setSent(true);
  };

  const handleClose = () => {
    setEmail("");
    setSent(false);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          alignItems: isMobile ? "flex-start" : "center",
          mt: isMobile ? 11 : 0,
        },
      }}
    >
      <DialogTitle>Passwort vergessen</DialogTitle>

      <DialogContent>
        {!sent ? (
          <>
            <Typography sx={{ mb: 2 }}>Gib deine E-Mail ein:</Typography>

            <TextField
              fullWidth
              label="E-Mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </>
        ) : (
          <Typography>
            ✅ Falls die E-Mail existiert, wurde ein Link gesendet.
          </Typography>
        )}
      </DialogContent>

      <DialogActions>
        {/* ✅ CLOSE BUTTON */}
        <Button onClick={onClose}>Schliessen</Button>

        {/* ✅ SEND BUTTON */}
        {!sent && (
          <Button variant="contained" onClick={handleSubmit}>
            Link senden
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
